









































import {Vue, Component} from "vue-property-decorator";
import {TipVozila} from "../../../services/BackendProxies";
import dataProxy from "../../../services/data-proxy.service";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class TipoviVozila extends mixins(ComponentBaseMixin) {
    columns;
    options = {
        pagination: true,
        search: true,
        onClickRow: tip => this.edit(tip)
    };
    dataSource = [];
    tipVozila = new TipVozila();

    async created() {
        this.columns = [{field: "naziv", title: this.$i18n.t("naziv")}];
        this.dataSource = await this.loadData<TipVozila[]>(() =>
            dataProxy.vratiTipoveVozila()
        )();
    }

    edit(row: TipVozila) {
        this.tipVozila = row;
    }

    kreirajNovTip() {
        this.tipVozila = new TipVozila();
        (<HTMLElement>this.$refs.naziv).focus();
    }

    async obrisiTip() {
        const da = await this.confirmationNeeded("da li zelite da obrisete tip vozila");
        if (da) {
            this.dataSource = await this.deleteData(() => dataProxy.obrisiTipVozila(this.tipVozila.id))();
            this.kreirajNovTip();
        }
    }

    async sacuvajTip() {
        const isValid = await (<any>this.$refs.form).validate();
        if (isValid) {
            this.tipVozila.id = await this.saveData(() => dataProxy.sacuvajTipVozila(this.tipVozila))();
            this.dataSource = await this.loadData(() => dataProxy.vratiTipoveVozila())();
        }
    }
}
